import { Box, Flex, Label, Text } from '@theme-ui/components';
import styled from '@emotion/styled';

import CloseIcon from '@app/assets/icons/CloseIcon';
import LoginLink from '@app/components/LoginLink';
import { fadeIn } from '@app/styles/animations';
import { screenSmall } from '@app/styles/theme/breakpoints';
import { rem } from '@app/styles/theme/layout';

import { UnstyledButton } from '../Button';

const Container = styled(Box)`
  position: fixed;
  left: 50%;
  bottom: ${rem(30)};
  transform: translateX(-50%);
  z-index: 4;
  width: ${rem(710)};
  padding: 2rem 4.5rem 2rem 2rem;
  border-radius: ${rem(4)};
  background: ${({ theme }) => theme.colors.blackSecondary};
  box-shadow: ${({ theme }) => `0px 4px 8px ${theme.colors.blackT25}`};
  animation: ${fadeIn} 0.3s;

  @media screen and (max-width: ${screenSmall}) {
    max-width: calc(100% - 3rem);
    bottom: 1.5rem;
  }
`;

const CloseButton = styled(UnstyledButton)`
  position: absolute;
  top: ${rem(34)};
  right: 2rem;

  @media screen and (max-width: ${screenSmall}) {
    top: ${rem(28)};
    right: 1.5rem;
  }
`;

const IconClose = styled(CloseIcon)`
  width: 1rem;
  height: 1rem;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    opacity: 0.8;
  }

  > path {
    fill: ${({ theme }) => theme.colors.productFinderBg};
  }
`;

const Content = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: ${screenSmall}) {
    align-items: flex-start;
  }
`;

const Headline = styled(Label)`
  justify-content: center;
  font-weight: 500;
  font-size: ${rem(18)};
  line-height: 1.3em;
  color: ${({ theme }) => theme.colors.productFinderBg};

  @media screen and (max-width: ${screenSmall}) {
    justify-content: flex-start;
  }
`;

const BodyText = styled(Text)`
  margin-top: 0.5rem;
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: 1.5em;
  text-align: center;
  color: ${({ theme }) => theme.colors.productFinderBg};

  @media screen and (max-width: ${screenSmall}) {
    text-align: left;
  }
`;

const LoginButton = styled(LoginLink)`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rem(35)};
  padding: ${rem(8)} ${rem(16)};
  background: ${({ theme }) => theme.colors.productFinderBg};
  font-size: ${rem(14.4)};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.blackSecondary};
  transition: 0.3s;

  &:hover {
    opacity: 0.8;
  }
`;

export {
  Container,
  CloseButton,
  IconClose,
  Content,
  Headline,
  BodyText,
  LoginButton,
};
